import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  IconButton,
  Paper,
  TextField,
  useMediaQuery,
} from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { PieChart, Pie, Sector, Cell, LineChart, Line, Brush } from "recharts";
import ApprovalIcon from "@mui/icons-material/Approval";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CheckIcon from "@mui/icons-material/Check";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateRangePicker } from "@mui/lab";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import { Stack } from "@mui/system";
import store from "../Store/index";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

function DashboardContent() {
  const [sanction, setSanction] = useState(0);
  const [request, setRequest] = useState(0);
  const [partialAmount, setPartialAmount] = useState(0);
  const [approved, setApproved] = useState(0);
  const [sanctionAmount, setSanctionAmount] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const [oneMonthData, setOneMonthData] = useState([]);
  const [oneYearData, setOneYearData] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [monthList, setMonthList] = useState([
    { value: "1", text: "Jan" },
    { value: "2", text: "Feb" },
    { value: "3", text: "Mar" },
    { value: "4", text: "Apr" },
    { value: "5", text: "May" },
    { value: "6", text: "Jun" },
    { value: "7", text: "Jul" },
    { value: "8", text: "Aug" },
    { value: "9", text: "Sep" },
    { value: "10", text: "Oct" },
    { value: "11", text: "Nov" },
    { value: "12", text: "Dec" },
  ]);
  const [month, setMonth] = useState((new Date().getMonth() + 1).toString());
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  const [loading, setLoading] = useState(true);
  const branches = store.getState().branch.branches;

  useEffect(() => {
    const getYearList = async () => {
      const response = await axios.post(
        "/dashboard/getYearListBasedOnDisbursementData"
      );
      const years = response.data;
      const values = years.map((val) => {
        return { value: val, text: val };
      });
      setYearList([...values]);
    };
    if (branches && branches.length > 0) {
      setLoading(false);
      getYearList();
      getDashBoardData();
    }
  }, [branches]);

  const getSelectedBranchCodes = (branchValues) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValues = branchWithCodes
      .filter((branch) => branchValues.includes(branch.label))
      .map((branch) => branch.code);
    return branchCodeValues;
  };

  const getDashBoardData = async (value, key) => {
    const loadBranchNames = GetBranchDetails();
    const branchCodeValues = getSelectedBranchCodes(
      loadBranchNames.map((data) => data.label)
    );
    const dataMap = {
      month: key === "month" ? value : month,
      year: key === "year" ? value : year,
      branches: loadBranchNames.map((data) => data.label),
      branchCodes: branchCodeValues,
    };
    try {
      // const response = await axios(
      const response = await axios.post("/dashboard/getDashboardData", dataMap);
      if (response.data) {
        setSanction(
          response.data.sanctioned > 0 ? response.data.sanctioned : 0
        );
        setRequest(response.data.requested);
        setApproved(response.data.approved);
        setPartialAmount(response.data.partialAmount);
        setSanctionAmount(
          "" === response.data.approvedAmount
            ? 0
            : Number(response.data.approvedAmount).toLocaleString("en-IN")
        );
        setOneMonthData(response.data.oneMonth);
        setOneYearData(response.data.oneYear);
      }
    } catch {
      console.log("Network Error");
    }
  };

  return (
    <React.Fragment>
      <Box sx={{ width: "100%" }}>
        {loading && (
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Box>
      {!loading && (
        <React.Fragment>
          <div
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "0",
              direction: "rtl",
            }}
          >
            <div
              style={{
                direction: "rtl",
                width: deviceModeValue ? "80%" : "23%",
              }}
            >
              <Stack direction="row" spacing={2}>
                <CustomDropDown
                  id="1"
                  label=""
                  value={year}
                  defaultValue="4"
                  required={false}
                  dropDownValue={yearList}
                  variant="standard"
                  onChange={(event) => {
                    setYear(event.target.value);
                    getDashBoardData(event.target.value, "year");
                  }}
                ></CustomDropDown>
                <Typography sx={{ marginTop: "8px !important" }}>
                  Year
                </Typography>
                <CustomDropDown
                  id="1"
                  label=""
                  value={month}
                  defaultValue="2"
                  required={false}
                  dropDownValue={monthList}
                  variant="standard"
                  onChange={(event) => {
                    setMonth(event.target.value);
                    getDashBoardData(event.target.value, "month");
                  }}
                ></CustomDropDown>
                <Typography sx={{ marginTop: "8px !important" }}>
                  Month
                </Typography>
              </Stack>
            </div>
          </div>
          <Grid
            container
            spacing={1}
            sx={{
              marginTop: "2px",
              marginLeft: "2px",
              width: "fit-content !important",
            }}
          >
            <Grid item xs={12} lg={2.4} sm={6} sx={{ flex: "1 auto" }}>
              <Card id="card-design">
                <CardHeader
                  // action={
                  //   <IconButton size="small">
                  //     <OpenInFullIcon size="small" />
                  //   </IconButton>
                  // }
                  subheader="Sanctioned"
                  subheaderTypographyProps={{
                    color: "white",
                    fontWeight: "700",
                  }}
                  sx={{ textAlign: "center" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: "700", fontSize: "2.0rem" }}
                    variant="h5"
                    component="h5"
                  >
                    {sanction}
                  </Typography>
                  <ApprovalIcon sx={{ fontSize: 50 }} />
                  {/* <Typography variant="body2" sx={{ color: "blue" }}>
            16.1%
          </Typography>
          <Typography variant="subtitle2">vs previous month</Typography> */}
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} lg={2.4} sm={6} sx={{ flex: "1 auto" }}>
              <Card id="card-design">
                <CardHeader
                  // action={
                  //   <IconButton size="small">
                  //     <OpenInFullIcon size="small" />
                  //   </IconButton>
                  // }
                  subheader="Requested"
                  subheaderTypographyProps={{
                    color: "white",
                    fontWeight: "700",
                  }}
                  sx={{ textAlign: "center" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: "700", fontSize: "2.0rem" }}
                    variant="h5"
                    component="h5"
                  >
                    {request}
                  </Typography>
                  <PendingActionsIcon sx={{ fontSize: 50 }} />
                  {/* <Typography variant="body2" sx={{ color: "red" }}>
            -8.8%
          </Typography>
          <Typography variant="subtitle2">vs previous month</Typography> */}
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} lg={2.4} sm={6} sx={{ flex: "1 auto" }}>
              <Card id="card-design">
                <CardHeader
                  // action={
                  //   <IconButton size="small">
                  //     <OpenInFullIcon size="small" />
                  //   </IconButton>
                  // }
                  subheader="Approved"
                  subheaderTypographyProps={{
                    color: "white",
                    fontWeight: "700",
                  }}
                  sx={{ textAlign: "center" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: "700", fontSize: "2.0rem" }}
                    variant="h5"
                    component="h5"
                  >
                    {approved}
                  </Typography>
                  <CheckIcon sx={{ fontSize: 50 }} />
                  {/* <Typography variant="body2" sx={{ color: "blue" }}>
            25.1%
          </Typography>
          <Typography variant="subtitle2">vs previous month</Typography> */}
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} lg={2.4} sm={6} sx={{ flex: "1 auto" }}>
              <Card id="card-design">
                <CardHeader
                  // action={
                  //   <IconButton size="small">
                  //     <OpenInFullIcon size="small" />
                  //   </IconButton>
                  // }
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                  subheader="Part Disbursed"
                  subheaderTypographyProps={{
                    color: "white",
                    fontWeight: "700",
                  }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: "700", fontSize: "2.0rem" }}
                    component="h5"
                  >
                    {partialAmount}
                  </Typography>
                  <HourglassBottomIcon sx={{ fontSize: 50 }} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} lg={2.4} sm={6} sx={{ flex: "1 auto" }}>
              <Card id="card-design">
                <CardHeader
                  // action={
                  //   <IconButton size="small">
                  //     <OpenInFullIcon size="small" />
                  //   </IconButton>
                  // }
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                  subheader="Disbursed (₹)"
                  subheaderTypographyProps={{
                    color: "white",
                    fontWeight: "700",
                  }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    fontWeight: "700",
                    fontSize: "2.0rem",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: "700", fontSize: "2.0rem" }}
                    variant="h5"
                    component="h5"
                  >
                    {sanctionAmount}
                  </Typography>
                  <AssuredWorkloadIcon sx={{ fontSize: 50 }} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sx={{ flex: "1 auto" }}>
              <Paper
                id="monthwise-chart"
                height={200}
                width="fit-content"
                sx={{
                  alignContent: "center",
                  textAlign: "center",
                  lineHeight: "1rem",
                }}
              >
                <LineChart
                  width={window.innerWidth - 24}
                  height={200}
                  data={oneMonthData}
                  marginLeft={-30}
                  syncId="anyId"
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                  sx={{ background: "aliceblue" }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="Requested"
                    stroke="#82ca9d"
                    fill="#82ca9d"
                  />
                </LineChart>
                <Typography
                  variant="subtitle2"
                  sx={{
                    pt: "8px",
                    color: "black",
                    fontSize: "1.3rem !important",
                    fontWeight: "500",
                  }}
                >
                  Requested List For Current Month
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sx={{ flex: "1 auto" }}>
              <Paper
                height={200}
                width="fit-content"
                id="monthwise-char"
                sx={{
                  alignContent: "center",
                  textAlign: "center",
                  lineHeight: "1rem",
                }}
              >
                <LineChart
                  width={window.innerWidth - 24}
                  height={200}
                  data={oneYearData}
                  syncId="anyId"
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="Approved"
                    stroke="#82ca9d"
                    fill="#82ca9d"
                  />
                </LineChart>
                <Typography
                  variant="subtitle2"
                  sx={{
                    pt: "8px",
                    color: "black",
                    fontSize: "1.3rem !important",
                    fontWeight: "500",
                  }}
                >
                  Approved List for Current Month
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default function DashboardBoardNewContent() {
  return <DashboardContent />;
}
